import React from 'react';
import { Link as ReactLink } from 'react-router-dom';
import styled from 'react-emotion';

const Menu = styled('nav')({
  borderRadius: '10px',
  display: 'block',
  margin: '0 10px',
  marginBottom: '10px',
  textAlign: 'center',
}, ({ theme }) => ({
  backgroundColor: theme.menu.backgroundColor,
  ...theme.media.grid({
    borderRadius: '20px',
    padding: '20px 0',
    margin: 0,
    textAlign: 'left',
  })
}));

const List = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

const Item = styled('li')({
  margin: 0,
  padding: 0,
  display: 'inline-block',
  backgroundColor: 'transparent',
}, ({ theme }) => ({
  ':hover': {
    backgroundColor: theme.menu.linkColor,
  },
  ...theme.media.grid({
    display: 'block',
  })
}));

const Link = styled(ReactLink)({
  textDecoration: 'none',
  padding: '0 0.5em',
  display: 'block',
}, ({ theme }) => ({
  color: theme.menu.linkColor,
  ':hover': {
    color: theme.menu.hoverColor,
  },
  ...theme.media.grid({
    padding: '5px 10px',
  })
}));

export default () => (
  <Menu>
    <List>
      <Item><Link to='/store/'>Corsets</Link></Item>
      <Item><Link to='/commission/'>Commissions</Link></Item>
      <Item><Link to='/measurements/'>Measurements</Link></Item>
      <Item><Link to='/history/'>History</Link></Item>
      <Item><Link to='/faq/'>FAQ</Link></Item>
      <Item><Link to='/about/'>Contact Us</Link></Item>
    </List>
  </Menu>
);



// WEBPACK FOOTER //
// ./src/structure/menu/menu.js